module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topbar"
    }
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('span', {
    staticClass: "logo"
  }, [_vm._v("Resumer")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [(_vm.logined) ? _c('div', {
    staticClass: "userActions"
  }, [_c('span', {
    staticClass: "weclome"
  }, [_vm._v("你好，" + _vm._s(_vm.user.username))]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signOut($event)
      }
    }
  }, [_vm._v("登出")])]) : _c('div', {
    staticClass: "userActions"
  }, [_c('a', {
    staticClass: "button primary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signUpDialogVisible = true
      }
    }
  }, [_vm._v("注册")]), _vm._v(" "), _c('a', {
    staticClass: "button",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.signInDialogVisible = true
      }
    }
  }, [_vm._v("登录")])])])]), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "注册",
      "visible": _vm.signUpDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signUpDialogVisible = false
      }
    }
  }, [_c('SignUpForm', {
    on: {
      "success": function($event) {
        _vm.signIn($event)
      }
    }
  })], 1), _vm._v(" "), _c('MyDialog', {
    attrs: {
      "title": "登录",
      "visible": _vm.signInDialogVisible
    },
    on: {
      "close": function($event) {
        _vm.signInDialogVisible = false
      }
    }
  }, [_c('SignInForm', {
    on: {
      "success": function($event) {
        _vm.signIn($event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-a0a88fb8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Topbar.vue
// module id = 80
// module chunks = 1